module.exports = __webpack_public_path__ + "static/media/2-teacher-2.5174d364.webp";